import {BlockType} from './BlockType';

export enum GeneralControls {
  ANCHOR_LINK_CONTAINER = 'anchorLinkFormContainer',
  APPLY_CONDITION = 'applyCondition',
  APPLY_CONDITION_SWITCHER = 'applyConditionSwitcher',
  BACKGROUND_COLOR = 'backgroundColor',
  BACKGROUND_IMAGE = 'generalImageContainer',
  TEXT_COLOR = 'textColor',
  TEXT_STYLE = 'textStyle',
  TEXT_SIZE = 'textSize',
  TEXT_LINE_SPACING = 'textLineSpacing',
  TEXT_ALIGN = 'textAlign',
  FIXED_HEIGHT_SWITCHER = 'fixedHeightSwitcherForm',
  HIDDEN_NODE = 'hiddenNode',
  SMART_BLOCK = 'smartBlock',
  SYNCHRONIZED_MODULE = 'synchronizedModuleForm',
  FONT_FAMILY = 'generalFontFamilyForm',
  BLOCK_INTERNAL_INDENTS = 'generalBlockInternalIndents',
  STRUCTURE_INTERNAL_INDENTS = 'generalStructureInternalIndents',
}

export enum BannerControls {
  ALIGNMENT = 'bannerAlignment',
  ALT_TEXT = 'bannerAltText',
  ANCHOR_LINK_CONTAINER = 'bannerAnchorLinkContainerForm',
  ASPECT_RATIO = 'bannerAspectRatioForm',
  BACKGROUND_COLOR = 'bannerBackgroundColor',
  BACKGROUND_IMAGE_CONTAINER = 'bannerBackgroundImageContainer',
  SIZE = 'bannerBlockBannerSize',
  BLOCK_LINK = 'bannerBlockLink',
  CHILD_ROTATION = 'bannerChildRotationForm',
  CROP = 'bannerCropForm',
  FILTER = 'bannerFilter',
  EXTERNAL_INDENTS = 'bannerExternalIndents',
  MIME_TYPE = 'bannerMimeTypeForm',
  RESPONSIVE_IMAGE = 'bannerResponsiveImageForm',
}

export enum BannerChildControls {
  ADDITIONAL_IMAGE = 'bannerAdditionalImageForm',
  ADDITIONAL_IMAGE_ASPECT_RATIO = 'bannerAdditionalImageAspectRatioForm',
  CHILD_COLOR = 'bannerChildColorForm',
  CHILD_FLIP = 'bannerChildFlipForm',
  CHILD_OPACITY = 'bannerChildOpacityForm',
  TEXT_ALIGNMENT = 'bannerTextAlignmentForm',
  TEXT_FONT = 'bannerTextFontContainer',
  TEXT_LETTER_CASE = 'bannerTextLetterCaseForm',
  TEXT_STYLE = 'bannerTextStyleForm',
}

export enum ButtonControls {
  ADJUST_TO_WIDTH = 'adjustToWidth',
  ALIGNMENT = 'buttonAlignment',
  BORDER = 'buttonBorder',
  BORDER_RADIUS = 'buttonBorderRadius',
  COLOR = 'buttonColor',
  BUTTON_BLOCK_BACKGROUND_COLOR = 'buttonBlockBackgroundColor',
  EXTERNAL_INDENTS = 'buttonExternalIndents',
  FIXED_HEIGHT = 'buttonFixedHeightForm',
  FONT_COLOR = 'buttonFontColor',
  FONT_FAMILY = 'buttonFontFamily',
  FONT_SIZE = 'buttonFontSize',
  FONT_WEIGHT = 'buttonFontWeight',
  ICON = 'buttonIconContainer',
  ICON_ALIGN = 'buttonIconAlign',
  ICON_INDENT = 'buttonIconIndent',
  ICON_WIDTH = 'buttonIconWidth',
  IMAGE = 'buttonImageForm',
  INTERNAL_INDENTS = 'buttonInternalIndents',
  LINK = 'buttonLink',
  MIME_TYPE = 'buttonMimeTypeForm',
  SWITCHER_HOVERED_STYLES = 'buttonSwitcherHoveredStylesForm',
  TEXT = 'buttonText',
  TEXT_STYLE_AND_COLOR = 'buttonTextStyleAndColorForm',
  HOVERED_BORDER_COLOR = 'hoveredStyleBorderButtonForm',
  HOVERED_COLOR = 'hoveredButtonColorForm',
  HOVERED_TEXT_COLOR = 'hoveredButtonTextColorForm',
}

export enum TextControls {
  HIDDEN_NODE = 'hiddenNodeText',
  PARAGRAPH_STYLE = 'paragraphStyleForm',
  ALIGN = 'textAlignmentForm',
  ANCHOR_CONTAINER = 'textAnchorForm',
  FONT_BACKGROUND_COLOR = 'textBlockFontBackgroundColor',
  TEXT_BLOCK_BACKGROUND_COLOR = 'textBlockBackgroundColor',
  FONT_COLOR = 'textBlockFontColor',
  TEXT_BLOCK_FONT_FAMILY = 'textBlockFontFamily',
  FONT_FAMILY = 'textFontFamily',
  FONT_SIZE = 'textBlockFontSize',
  FONT_WEIGHT = 'textBlockFontWeight',
  DIRECTION = 'textBlockDirectionForm',
  INSERT_FORM = 'textBlockInsertForm',
  LINK_DATA = 'textBlockLinkDataForm',
  FORMAT = 'textBlockTextFormatForm',
  FIXED_HEIGHT = 'textFixedHeightForm',
  INTERNAL_INDENTS = 'textInternalIndents',
  LINE_HEIGHT = 'textLineHeightForm',
  MIME_TYPE = 'textMimeTypeForm',
  NO_LINE_WRAPS = 'textNoLineWrapsForm',
}

export enum AmpFormControls {
  AMP_FORM_HIDDEN_NODE = 'ampFormHiddenNodeForm',
  AMP_FORM_DATA_COLLECTION = 'ampFormDataCollectionForm',
  AMP_FORM_MIME_TYPE = 'ampFormMimeTypeForm',
  BACKGROUND_COLOR = 'ampFormBackgroundColorForm',
}

export enum VideoControls {
  CUSTOM_THUMBNAIL_CONTAINER = 'customThumbnailContainerForm',
  METADATA_LINK = 'metadataLink',
  PLAY_BUTTON = 'playButton',
  ALIGNMENT = 'videoAlignment',
  ALT_TEXT = 'videoAltText',
  EXTERNAL_INDENTS = 'videoExternalIndents',
  MIME_TYPE = 'videoMimeTypeForm',
  RESPONSIVE = 'videoResponsive',
  SIZE = 'videoSizeContainer',
}

export enum TimerControls {
  ALIGNMENT = 'timerAlignment',
  ALT_TEXT = 'timerAltText',
  BACKGROUND_COLOR = 'timerBackgroundColor',
  DATE_TIME = 'timeDateTime',
  DIGITAL_LABELS = 'timerDigitalLabels',
  DIGITS_FONT_COLOR_CONTAINER = 'timerDigitsFontColorContainer',
  DIGITS_FONT_CONTAINER = 'timerDigitsFontContainer',
  DISPLAY_DAYS_SWITCHER = 'timerDisplayDaysSwitcher',
  EXPIRATION_IMAGE = 'timerExpirationImage',
  EXPIRATION_IMAGE_SWITCHER = 'timerExpirationSwitcher',
  EXTERNAL_INDENTS = 'timerExternalIndents',
  LABELS_CASE = 'timerLabelsCase',
  LABELS_FONT_COLOR_CONTAINER = 'timerLabelsFontColorContainer',
  LABELS_FONT_CONTAINER = 'timerLabelsFontContainer',
  LABEL_LANGUAGE = 'timerLabelsLanguage',
  LINK = 'timerLink',
  MIME_TYPE = 'timerMimeTypeForm',
  RESPONSIVE = 'timerResponsive',
  RETINA_DISPLAY_SUPPORT = 'timerRetinaDisplaySupport',
  SEPARATOR = 'timerSeparator',
  SEPARATOR_FONT_COLOR = 'timerSeparatorFontColor',
  SEPARATOR_FONT_CONTAINER = 'timerSeparatorFontContainer',
  SIZE = 'timerSize',
  TIME_ZONE = 'timerTimeZone',
}

export enum SpacerControls {
  ALIGNMENT = 'spacerAlignment',
  BORDER = 'spacerBorder',
  EXTERNAL_INDENTS = 'spacerExternalIndents',
  MIME_TYPE = 'spacerMimeTypeForm',
  MODE = 'spacerMode',
  SIZE = 'spacerSize',
  BACKGROUND_COLOR = 'spacerBackgroundColor',
  BACKGROUND_COLOR_LINE = 'spacerBackgroundColorLine',
}

export enum ImageControls {
  ALT_TEXT = 'altText',
  LINK = 'blockLink',
  ALIGNMENT = 'imageAlignment',
  ANCHOR_LINK_CONTAINER = 'imageAnchorLinkContainerForm',
  BORDER_RADIUS = 'imageBorderRadiusForm',
  IMAGE = 'imageImageForm',
  EXTERNAL_INDENTS = 'imageExternalIndents',
  MIME_TYPE = 'imageMimeTypeForm',
  RESPONSIVE = 'imageResponsive',
  ROLLOVER_IMAGE = 'imageRolloverImageForm',
  ROLLOVER_SWITCHER = 'imageRolloverSwitcherForm',
  SIZE = 'imageSizeContainer',
}

export enum HTMLControls {
  EXTERNAL_INDENTS = 'htmlExternalIndents',
  MIME_TYPE = 'htmlMimeTypeForm',
}

export enum CustomLinkControls {
  IMAGE = 'customBlockImageForm',
  COLOR_FORM = 'customLinkColorForm',
  HREF_FORM = 'customLinkHrefForm',
  TEXT_FORM = 'customLinkTextForm',
  UNDERLINE_FORM = 'customLinkUnderlineForm',
  WORD_BREAK_FORM = 'customLinkWordBreakForm',
}

export enum CustomImageControls {
  ALT_TEXT_FORM = 'customBlockImageAltTextForm',
  WITHOUT_LINK_FORM = 'customBlockImageWithOutLinkForm',
}

export enum CustomTextControls {
  ALIGN = 'customTextBlockTextAlign',
  FONT_SIZE = 'customTextFontSizeController',
}

export enum SocialControls {
  ICON_SIZE = 'iconSize',
  EXTERNAL_INDENTS = 'socialExternalIndents',
  ICON_SPACER = 'socialIconsSpacer',
  ICON_TYPE = 'socialIconTypeForm',
  ITEM = 'socialItemForm',
  ITEM_TEXT_CUSTOMIZATION = 'socialItemTextCustomizationForm',
  MIME_TYPE = 'socialMimeTypeForm',
  NETWORK_ALIGNMENT = 'socialNetworkAlignment',
  BACKGROUND_COLOR = 'socialBackgroundColor',
}

export enum MenuControls {
  EXTERNAL_INDENTS = 'menuExternalIndents',
  ALIGNMENT = 'menuAlignment',
  RESPONSIVE_MENU = 'menuResponsive',
  FIT_TO_CONTAINER = 'menuFitToContainer',
  FONT_FAMILY = 'menuFontFamily',
  FONT_SIZE = 'menuFontSize',
  HIDDEN = 'menuHidden',
  ICONS_CONFIGURATION = 'menuIconsConfiguration',
  ITEMS = 'menuItemsForm',
  ITEMS_COUNT = 'menuItemsCount',
  ITEM_INTERNAL_INDENTS = 'menuItemInternalIndents',
  MIME_TYPE = 'menuMimeTypeForm',
  SEPARATE_ITEMS = 'menuSeparateItems',
  SEPARATE_ITEMS_COLOR_SWITCHER = 'menuSeparateItemsColorSwitcher',
  SEPARATOR = 'menuSeparatorForm',
  STYLES = 'menuStylesForm',
  TEXT_STYLE_AND_COLOR = 'menuTextStyleAndColor',
  TYPE_CONTAINER = 'menuTypeContainerForm',
}

export enum AccordionControls {
  MIME_TYPE = 'ampAccordionMimeTypeForm',
  ANIMATED_OPENING = 'ampAccordionAnimatedOpeningForm',
  AUTO_COLLAPSING = 'ampAccordionAutoCollapsingForm',
  BORDER_FORM = 'ampAccordionBorderForm',
  FONT_FAMILY = 'ampAccordionFontFamily',
  ICON_SIZE = 'ampAccordionIconSizeForm',
  HIDDEN_NODE = 'ampAccordionHiddenNodeForm',
  SECTIONS_FORM = 'ampAccordionSectionsForm',
  SECTIONS_GAP_FORM = 'ampAccordionSectionsGapForm',
  SECTIONS_MAIN_FORM = 'ampAccordionSectionsMainForm',
  TITLES_BACKGROUND_COLOR = 'ampAccordionTitlesBackgroundColor',
  TITLE_ALIGNMENT_FORM = 'ampAccordionTitleAlignmentForm',
  TITLE_FONT_SIZE = 'AmpAccordionTitleFontSizeController',
  TITLE_ICON_IMAGE = 'ampAccordionTitleIconImageForm',
  TITLE_ICON_SWITCHER = 'ampAccordionTitleIconSwitcherForm',
  TITLE_TEXT_STYLE_AND_COLOR = 'AmpAccordionTitleTextStyleAndColorController',
}

export enum CarouselControls {
  MIME_TYPE = 'ampCarouselMimeTypeForm',
  AUTOPLAY = 'ampCarouselAutoplayForm',
  AUTOPLAY_DELAY = 'ampCarouselDelayForm',
  HIDDEN_NODE = 'ampCarouselHiddenNodeForm',
  LOOP = 'ampCarouselLoopForm',
  SLIDES = 'ampSlidesForm',
  SLIDE_ALT_TEXT = 'ampSlideAltTextForm',
  SLIDE_IMAGE = 'ampSlideImageForm',
  SLIDE_IMAGE_FIT = 'ampCarouselSlideImageFitForm',
  SLIDE_LINK = 'ampSlideLinkForm',
  SLIDE_RADIUS = 'ampCarouselSlideRadiusForm',
  SLIDE_THUMBNAIL_SWITCHER = 'ampCarouselSlideThumbnailSwitcherForm',
  THUMBNAIL_BORDER_STYLE = 'ampCarouselThumbnailBorderStyleForm',
  THUMBNAIL_CONTAINER = 'ampCarouselThumbnailContainerForm',
  THUMBNAIL_CUSTOM_REVIEW = 'ampCarouselThumbnailCustomPreviewImageForm',
  THUMBNAIL_RADIUS = 'ampCarouselThumbnailRadiusForm',
  THUMBNAIL_COLOR = 'ampCarouselThumbnailColorForm',
  AMP_GENERAL_LINK = 'AMP_GENERAL_LINK_CONTROLLER',
  AMP_GENERAL_LINK_SWITCHER = 'AMP_GENERAL_LINK_SWITCHER',
}

export enum StripeControls {
  BORDER_FORM = 'stripeBorderForm',
  COLOR = 'stripeColorForm',
  CONTENT_COLOR = 'stripeContentColor',
  IMAGE_CONTAINER = 'stripeImageContainerForm',
  INTERNAL_INDENTS = 'stripeInternalIndents',
  MESSAGE_AREA = 'stripeMessageAreaForm',
  MIME_TYPE = 'stripeMimeTypeForm',
}

export enum StructureControls {
  RESPONSIVE_STRUCTURE = 'responsiveStructure',
  BACKGROUND_COLOR = 'structureBackgroundColor',
  BORDER_RADIUS = 'structureBorderRadiusForm',
  CONTAINER_GAP = 'structureContainerGap',
  CONTAINER_INVERSION = 'structureContainerInversion',
  DYNAMIC_CONTAINERS = 'structureDynamicContainers',
  EXTERNAL_INDENTS = 'structureExternalIndents',
  IMAGE_CONTAINER = 'structureImageContainerForm',
  INTERNAL_INDENTS = 'structureInternalIndents',
  ITEM = 'structureItem',
  MIME_TYPE = 'structureMimeType',
  BORDER_FORM = 'structureBorderForm',
}

export enum ContainerControls {
  BACKGROUND_COLOR = 'containerBackgroundColorForm',
  BORDER_FORM = 'containerBorderForm',
  BORDER_RADIUS = 'containerBorderRadiusForm',
  EXTERNAL_INDENTS = 'containerExternalIndentsForm',
  IMAGE_CONTAINER = 'containerImageContainerForm',
  MIME_TYPE = 'containerMimeTypeForm',
  DISPLAY_CONDITIONS = 'displayConditions',
  HIDDEN_NODE = 'containerHiddenNodeForm',
}

export enum MessageSettingsControls {
  GMAIL_PROMOTIONS_SWITCHER = 'gmailPromotionsSwitcherForm',
  GMAIL_PROMOTIONS_TAB = 'gmailPromotionsTabForm',
  HIDDEN_PRE_HEADER = 'hiddenPreHeaderForm',
  SUBJECT_TITLE = 'subjectTitleForm',
  UTM_PARAMETERS = 'utmParametersForm',
  UTM_PARAMETERS_CAMPAIGN = 'utmParameterCampaignForm',
  UTM_PARAMETERS_CUSTOM = 'utmParametersCustomForm',
  UTM_PARAMETERS_CUSTOM_ITEM = 'utmParametersCustomItemForm',
}

export enum GeneralStylesControls {
  BUTTONS_ADJUST_TO_WIDTH_CONTAINER = 'buttonsAdjustToWidthFormContainer',
  BUTTONS_BORDER = 'buttonsBorder',
  BUTTONS_BORDER_RADIUS_CONTAINER = 'buttonsBorderRadiusContainer',
  BUTTONS_COLOR_CONTAINER = 'buttonsColorContainer',
  BUTTONS_FONT_FAMILY_CONTAINER = 'buttonsFontFamilyContainer',
  BUTTONS_FONT_SIZE_CONTAINER = 'buttonsFontSizeFormContainer',
  BUTTONS_HOVERED_BUTTON_STYLE = 'buttonsHoveredButtonStyleForm',
  BUTTONS_INTERNAL_INDENTS_CONTAINER = 'buttonsInternalIndentsContainer',
  BUTTONS_LETTER_SPACING_CONTAINER = 'buttonsLetterSpacingContainer',
  BUTTONS_OUTLOOK_SUPPORT_CONTAINER = 'buttonsOutlookSupportContainer',
  BUTTONS_TEXT_STYLE_AND_COLOR_CONTAINER = 'buttonsTextStyleAndColorFormContainer',
  DEFAULT_STRUCTURE_INTERNAL_INDENTS = 'defaultStructureInternalIndents',
  GENERAL_BACKGROUND_COLOR_CONTAINER = 'generalBackgroundColorContainer',
  GENERAL_IMAGE_CONTAINER = 'generalImageContainer',
  HEADINGS_FONT_FAMILY_CONTAINER = 'headingsFontFamilyContainer',
  HEADINGS_H1_CONTROLS_CONTAINER = 'headingH1controlsContainer',
  HEADINGS_H2_CONTROLS_CONTAINER = 'headingH2controlsContainer',
  HEADINGS_H3_CONTROLS_CONTAINER = 'headingH3controlsContainer',
  HEADINGS_H4_CONTROLS_CONTAINER = 'headingH4controlsContainer',
  HEADINGS_H5_CONTROLS_CONTAINER = 'headingH5controlsContainer',
  HEADINGS_H6_CONTROLS_CONTAINER = 'headingH6controlsContainer',
  HEADINGS_LETTER_SPACING_CONTAINER = 'headingsLetterSpacingFormContainer',
  HEADINGS_PARAGRAPH_BOTTOM_MARGIN = 'headingsParagraphBottomMarginForm',
  HEADINGS_TYPES_BUTTON_BAR = 'headingsTypesButtonBarForm',
  LISTS_STYLES = 'listsStyles',
  MARGIN_AROUND_MESSAGE = 'marginAroundMessage',
  MESSAGE_ALIGNMENT = 'messageAlignment',
  MESSAGE_CONTENT_WIDTH = 'messageContentWidth',
  RESPONSIVE_DESIGN = 'responsiveDesign',
  HIDE_IMAGE_DOWNLOAD_ICONS = 'hideImageDownloadIcons',
  DEFAULT_STYLES = 'defaultStyles',
  RIGHT_TO_LEFT_CONTAINER = 'rightToLeftContainer',
  STRIPES_CONTENT_CONTROLS_CONTAINER = 'stripesContentControlsContainer',
  STRIPES_FONT_FAMILY_CONTAINER = 'stripesFontFamilyFormContainer',
  STRIPES_FOOTER_CONTROLS_CONTAINER = 'stripesFooterControlsContainer',
  STRIPES_HEADER_CONTROLS_CONTAINER = 'stripesHeaderControlsContainer',
  STRIPES_INFO_AREA_CONTROLS_CONTAINER = 'stripesInfoAreaControlsContainer',
  STRIPES_LETTER_SPACING_CONTAINER = 'stripesLetterSpacingFormContainer',
  STRIPES_LINE_HEIGHT_CONTAINER = 'stripesLineHeightFormContainer',
  STRIPE_TYPES_BUTTON_BAR = 'stripeTypesButtonBarForm',
  UNDERLINE_LINKS_CONTAINER = 'underlineLinksContainer',
}

/**
 * @description List of supported controls grouped by block ({@link BlockType}) or additional panel name
 */
export const BuiltInControlTypes = {
  [BlockType.BLOCK_BANNER]: BannerControls,
  [BlockType.BLOCK_BUTTON]: ButtonControls,
  [BlockType.BLOCK_TEXT]: TextControls,
  [BlockType.BLOCK_VIDEO]: VideoControls,
  [BlockType.BLOCK_TIMER]: TimerControls,
  [BlockType.BLOCK_SPACER]: SpacerControls,
  [BlockType.BLOCK_IMAGE]: ImageControls,
  [BlockType.BLOCK_HTML]: HTMLControls,
  [BlockType.BLOCK_SOCIAL]: SocialControls,
  [BlockType.BLOCK_MENU]: MenuControls,
  [BlockType.BLOCK_AMP_FORM]: AmpFormControls,
  [BlockType.BLOCK_AMP_ACCORDION]: AccordionControls,
  [BlockType.BLOCK_AMP_CAROUSEL]: CarouselControls,
  [BlockType.STRIPE]: StripeControls,
  [BlockType.STRUCTURE]: StructureControls,
  [BlockType.CONTAINER]: ContainerControls,
  [BlockType.CUSTOM_BLOCK_LINK]: CustomLinkControls,
  [BlockType.CUSTOM_BLOCK_IMAGE]: CustomImageControls,
  [BlockType.CUSTOM_BLOCK_TEXT]: CustomTextControls,
  BANNER_CHILD: BannerChildControls,
  MESSAGE_SETTINGS: MessageSettingsControls,
  GENERAL_STYLES: GeneralStylesControls,
  GENERAL: GeneralControls,
};
